/*
 * Copyright (c) 2020. Sayari LLC
 */
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
    templateUrl : './navbar.component.html',
    selector: 'app-navbar'
})
export class NavbarComponent implements OnInit{
    url = environment.webUiUrl;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.fragment.subscribe(f => {
            const element = document.querySelector('#' + f)
            if (element) {
                element.scrollIntoView();
            }
        });
    }
}
